import { Component } from '@angular/core';
import { NgIf } from '@angular/common';
import { DownloadCheckDialogComponent } from './download-check-dialog.component';
import { DownloadCheckDialogStateService } from './download-check-dialog-state.service';

@Component({
    selector: 'app-download-check-dialog-host',
    standalone: true,
    imports: [NgIf, DownloadCheckDialogComponent],
    template: '<app-download-check-dialog *ngIf="state.open()" [open]="state.open()" [payable]="state.payable()" (closed)="state.answer($event)"></app-download-check-dialog>',
})
export class DownloadCheckDialogHostComponent
{
    constructor(readonly state: DownloadCheckDialogStateService) {}
}
